import React from "react";
import Media from "react-resized";

const RenderSize = ({ media, mobile, desktop, props }) => {
  if (media === "standard") return React.createElement(desktop, { ...props });

  return React.createElement(mobile, props);
};
export default Media(RenderSize)(() => ["mobile", "standard", "standard"]);
